import { EditCitizenshipPanel } from '@features/profile/components/edit-citizenship-panel/EditCitizenshipPanel';
import { useProfileNavigation } from '@features/profile/hooks/use-profile-navigation/useProfileNavigation';
import * as React from 'react';

const EditCitizenshipRoute = React.memo((): React.ReactElement => {
  const { navigateToPersonalInformation } = useProfileNavigation();

  return <EditCitizenshipPanel onClose={navigateToPersonalInformation} />;
});

EditCitizenshipRoute.displayName = 'EditCitizenshipRoute';

export { EditCitizenshipRoute };
